module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qpelv3a-7d2b4eff3e256b37a4db0f9b4ad90578.jpg";